import React from 'react'
import './css/About.css'
import papa_img from '../Components/Assets/papa.png'
// import papa_img1 from '../Components/Assets/papa1.jpg'
import papa_img2 from '../Components/Assets/papa2.jpeg'
import papa_img3 from '../Components/Assets/papa3.jpeg'
import papa_img4 from '../Components/Assets/papa4.jpeg'

const About = () => {
  return (
    <div className='about' >
      <div className="papa-banner"><img src={papa_img} alt="" /></div>
      <div className="about-template">
      <div className="first-para">
        <img src={papa_img2} alt="" />
        <p><span>Since 1994</span>, I have dedicated my career to the world of sound, starting as a boom operator in the Hindi film industry. Over the years, I expanded my expertise and worked in various regional film industries, including Marathi, Malayalam, and English films. My passion for sound and deep understanding of the audio landscape has led me to establish SONIC WAVES in 2019.</p>
      </div>
      <div className="second-para">
        <p>At <span>SONIC WAVES</span>,we provide top-tier audio equipment rentals to film productions, ensuring that every project has access to the best possible tools for capturing sound. With decades of experience, we offer precision audio solutions that cater to the specific needs of each production. Additionally, we specialize in selling sound expendables, empowering sound mixers to enhance their audio experience during live recordings.</p>
        <img src={papa_img3} alt="" />
      </div>
      <div className="third-para">
        <img src={papa_img4} alt="" />
        <p><span>Our mission </span>is to deliver exceptional audio quality, drawing on years of hands-on experience in the industry. Whether you're looking for rental equipment, expert advice on what to buy or inovative audio solutions for your productions SONIC WAVES is here to elevate your audio experience to the next level..</p>
      </div>
      </div>
    </div>
  )
}

export default About